/**
 * The expiration time for invalidated items
 * @constant {number}
 */
export const EXP_INVALIDATED = -1;
export const DEFAULT_LIMIT = 10;
